// prod
export const VUE_APP_BASE_API = "https://park.crcspace.cn/"

// tesst
// export const VUE_APP_BASE_API = "https://cscpark.oramage.com"  

